import { render, staticRenderFns } from "./OrdersTableEs.vue?vue&type=template&id=626bba66&scoped=true"
import script from "./OrdersTableEs.vue?vue&type=script&lang=js"
export * from "./OrdersTableEs.vue?vue&type=script&lang=js"
import style0 from "./OrdersTableEs.vue?vue&type=style&index=0&id=626bba66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626bba66",
  null
  
)

export default component.exports